import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
	Form,
	Col,
	Card,
	Row,
	FormControl,
	Spinner
} from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import { GoogleMap, Marker, Autocomplete } from '@react-google-maps/api';
import { useJsApiLoader } from '@react-google-maps/api';
import { googleMapAPI } from '../../../config';

import Loader from '../../Common/Loader';
import Link from '../../Link/Link';
import LoginModal from '../LoginModal/LoginModal';
import HeaderModal from '../../HeaderModal/HeaderModal';
import ForgotPasswordModal from '../ForgotPassword/ForgotPasswordModal';

import s from './SignupForm.css';
import rs from '../../storeCommon.css';
import getLocationsQuery from './getLocations.graphql';

// Action
import { openLoginModal } from "../../../actions/modalActions";
import { openHeaderModal } from '../../../actions/siteadmin/modalActions';

import { formatLocale } from '../../../helpers/formatLocale';
import messages from '../../../locale/messages';
import validate from './validate';
import submit from './submit';
import { api, partnerHomepageUploadDir, logoUploadDir } from '../../../config';

//images
import languageIcon from '../../../../public/Icons/Language-black.svg';
import arrow from '../../../../public/Icons/right.svg';
import backArrow from '../../../../public/SiteImages/signupBackArrow.png';

import { change as changeFieldValue } from 'redux-form';

// Helper for functional map picker
function MapPicker({ lat, lng, onLocationChange }) {
	// Default center: Pulau Lombok
	const LOMBOK_CENTER = { lat: -8.652933, lng: 116.324538 };
	const center = {
		lat: lat || LOMBOK_CENTER.lat,
		lng: lng || LOMBOK_CENTER.lng
	};
	const [markerPos, setMarkerPos] = React.useState(center);
	const [mapRef, setMapRef] = React.useState(null);

	React.useEffect(() => {
		setMarkerPos(center);
		if (mapRef) {
			mapRef.panTo(center);
		}
	}, [lat, lng]);

	const handleMapClick = async (e) => {
		const newPos = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng()
		};
		setMarkerPos(newPos);
		onLocationChange(newPos);
	};

	const handleMarkerDragEnd = async (e) => {
		const newPos = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng()
		};
		setMarkerPos(newPos);
		onLocationChange(newPos);
	};

	const handleCurrentLocation = () => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					const newPos = {
						lat: position.coords.latitude,
						lng: position.coords.longitude
					};
					setMarkerPos(newPos);
					if (mapRef) mapRef.panTo(newPos);
					onLocationChange(newPos);
				},
				(err) => {
					alert('Unable to get your location.');
				}
			);
		} else {
			alert('Geolocation is not supported by your browser.');
		}
	};

	return (
		<div style={{ position: 'relative' }}>
			<button
				type="button"
				style={{ position: 'absolute', zIndex: 2, top: 10, right: 10, background: '#fff', border: '1px solid #ccc', borderRadius: 4, padding: '6px 12px', cursor: 'pointer' }}
				onClick={handleCurrentLocation}
			>
				📍 Current Location
			</button>
			<GoogleMap
				mapContainerStyle={{ width: '100%', height: 300 }}
				center={markerPos}
				zoom={10}
				onClick={handleMapClick}
				onLoad={map => setMapRef(map)}
			>
				<Marker
					position={markerPos}
					draggable
					onDragEnd={handleMarkerDragEnd}
				/>
			</GoogleMap>
		</div>
	);
}

function AddressAutocomplete({ value, onChange, onPlaceSelected, placeholder }) {
	const [autocomplete, setAutocomplete] = React.useState(null);

	const handleLoad = (autoC) => setAutocomplete(autoC);

	const handlePlaceChanged = () => {
		if (autocomplete) {
			const place = autocomplete.getPlace();
			if (place && place.formatted_address) {
				onChange(place.formatted_address);
				if (onPlaceSelected) onPlaceSelected(place);
			}
		}
	};

	return (
		<Autocomplete
			onLoad={handleLoad}
			onPlaceChanged={handlePlaceChanged}
		>
			<input
				type="text"
				className="form-control"
				value={value}
				onChange={e => onChange(e.target.value)}
				placeholder={placeholder}
				autoComplete="off"
			/>
		</Autocomplete>
	);
}

export class SignupForm extends Component {

	constructor(props) {
		super(props);

		this.state = {
			countryCode: 'ID',
			countryDialCode: '+62',
			phoneNumber: '',
			categories: [],
		};

		this.handleCountryChange = this.handleCountryChange.bind(this);
		this.handleLocationData = this.handleLocationData.bind(this);
		this.handleOnChange = this.handleOnChange.bind(this);
		this.changedeliveryType = this.changedeliveryType.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	static defaultProps = {
		loading: false
	};

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder }) => {
		const { formatMessage } = this.props.intl
		return (
			<Form.Group className={s.formGroup}>
				<Form.Control {...input}
					value={input.value || ''}
					placeholder={placeholder}
					type={type}
					className={fieldClass}
				/>
				{touched && error && <span className={cx(s.arrow_box, 'arrow_boxRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	};

	renderFormControlSelect = ({ input, label, meta: { touched, error }, children, className }) => {
		const { formatMessage } = this.props.intl;
		return (
			<>
				<FormControl as="select" {...input} className={className} >
					{children}
				</FormControl>
				{touched && error && <span className={cx(s.arrow_box, 'arrow_boxRTL')}>{formatMessage(error)}</span>}
			</>
		)
	}

	renderAddress = ({ input, meta: { touched, error } }) => {
		const { formatMessage } = this.props.intl;
		const { change } = this.props;
		return (
			<Form.Group className={cx(s.formGroup)}>
				<AddressAutocomplete
					value={input.value || ''}
					onChange={input.onChange}
					placeholder={formatMessage(messages.address)}
					onPlaceSelected={(place) => {
						const formatted = place.formatted_address;
						const location = place.geometry && place.geometry.location;
						if (formatted) {
							change('address', formatted);
						}
						if (location) {
							const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
							const lng = typeof location.lng === 'function' ? location.lng() : location.lng;
							change('lat', lat);
							change('lng', lng);
						}
						if (place.address_components) {
							const zipObj = place.address_components.find(c => c.types && c.types.includes('postal_code'));
							if (zipObj) change('zipcode', zipObj.long_name);
						}
					}}
				/>
				{touched && error && <span className={cx(s.arrow_box, 'arrow_boxRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		);
	};

	renderPhoneNUmber = ({ meta: { touched, error } }) => {
		const { formatMessage } = this.props.intl;
		const { phoneNumber } = this.state;
		return (
			<>
				<PhoneInput
					country={'id'}
					value={phoneNumber}
					onChange={this.handleOnChange}
					countryCodeEditable={false}
				/>
				{touched && error && <span className={cx(s.arrow_box, 'arrow_boxRTL')}>{formatMessage(error)}</span>}
			</>
		);
	}

	componentDidMount() {
		const { initialize, getCategories } = this.props;
		const { countryCode, countryDialCode } = this.state;

		initialize({
			phoneCountryCode: countryCode,
			phoneDialCode: countryDialCode,
			address: '',
			zipcode: '',
			lat: '',
			lng: ''
		});
	};


	handleLocationData(location) {
		const { change } = this.props;

		const addressLabel = location && location.label;
		const addressPosition = location && location.location;
		const locationArray = addressLabel && addressLabel.split(',').slice(-3).reverse();

		change('address', addressLabel)
		change('city', locationArray && locationArray[2] && locationArray[2].trim());
		change('state', locationArray && locationArray[1] && locationArray[1].trim());
		change('country', locationArray && locationArray[0] && locationArray[0].trim());
		change('lat', addressPosition && addressPosition.lat);
		change('lng', addressPosition && addressPosition.lng);
	};

	handleCountryChange(country, event) {
		const { change } = this.props;

		this.setState({
			countryCode: country.countryCode,
			countryDialCode: country.dialCode
		});

		change('phoneCountryCode', country.countryCode)
		change('phoneDialCode', country.dialCode)
	};

	handleOnChange(value, event) {
		const { change } = this.props;

		this.setState({ phoneNumber: value });
		const formattedNumber = value.replace(/[^0-9]+/g, '').slice(event.dialCode.length);
		const dialCode = `+${event.dialCode}`;
		const countryCode = event.countryCode.toUpperCase();

		change('phoneCountryCode', countryCode)
		change('phoneDialCode', dialCode)
		change('phoneNumber', formattedNumber)

	}

	changedeliveryType(e) {
		const { change, getCategories } = this.props;
		const newValue = Number(e.target.value);
		const data = getCategories && getCategories.result && getCategories.result.length > 0 && getCategories.result.filter(o => o.deliveryType === newValue);
		this.setState({
			categories: data
		});
	}

	handleChange(e) {
		const { openHeaderModal } = this.props;
		openHeaderModal('languageModal');
	}

	renderMapPicker = () => {
		const { lat, lng } = this.props;
		const { change } = this.props;
		// Handler to update redux-form fields and reverse geocode
		const handleLocationChange = ({ lat, lng }) => {
			change('lat', lat);
			change('lng', lng);
			if (window.google && window.google.maps) {
				const geocoder = new window.google.maps.Geocoder();
				geocoder.geocode({ location: { lat, lng } }, (results, status) => {
					if (status === 'OK' && results[0]) {
						change('address', results[0].formatted_address);
						const zipObj = results[0].address_components.find(comp =>
							comp.types.includes('postal_code')
						);
						if (zipObj) {
							change('zipcode', zipObj.long_name);
						}
					}
				});
			}
		};
		return (
			<MapPicker
				lat={lat || this.props.initialValues?.lat}
				lng={lng || this.props.initialValues?.lng}
				onLocationChange={handleLocationChange}
			/>
		);
	};

	render() {
		const { handleSubmit, submitting, loading, error, deliveryTypes, homepage, getLocations } = this.props;
		const { openLoginModal, currentLocale, logo, logoHeight, logoWidth, siteName } = this.props;
		const { countryCode, countryDialCode, phoneNumber, categories } = this.state;
		const { formatMessage } = this.props.intl;
		return (
			<div className={cx(s.responsiveNoPadding, 'tabLabelText', 'placeHolderText')}>
				<LoginModal />
				<ForgotPasswordModal />
				<HeaderModal />
				<div className={s.displayGrid}>
					<div className={s.bgImage} style={{ backgroundImage: `url(${api.apiEndpoint + partnerHomepageUploadDir + homepage.bannerImage2})` }}>
						<div className={s.positionRelative}>

							<Link to={'/'} className={s.backBtn}>
								<span className={'floatLeftRTL'}><img src={backArrow} alt='back arrow icon' /></span>
								<span>{formatMessage(messages.backToHome)}</span>
							</Link>

							<div className={s.innerSection}>
								<img
									src='/images/ASAP-logo.svg'
									style={{ maxHeight: '32px' }}
									alt={siteName}
								/>
								<div className={s.searchFormWrap}>
									<h1>
										{homepage.bannerTitle1}
									</h1>
									<p>
										{homepage.bannerContent1}
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className={s.sectionTwo}>
						<div className={s.alignRight}>

							<Link noLink
								onClick={(e) => this.handleChange(e)}
								className={cx(s.siteColor, s.cursurPointer)}>
								<span className={cx(s.languageIcon, 'languageIconRTL')}><img src={languageIcon} alt='language icon' /></span>
								<span>
									{formatLocale(currentLocale)}
								</span>
							</Link>

							<Link noLink
								to={'/store/login'}
								className={cx(s.storeLink, s.cursurPointer, 'signStoreRTL')}>
								<span><FormattedMessage {...messages.signin} /></span>
								<span className={'storeLinkRTL'}><img src={arrow} alt='arrow icon' /></span>
							</Link>

						</div>
						<Card className={s.card}>
							<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
								{/* Section 1: Store Information */}
								<h4 className={s.sectionTitle}>Store Information</h4>
								<div className={rs.spaceTop5}>
									<Form.Group className={cx(s.formGroup, 'signupCategorySelect')}>
										{error && <span className={s.arrow_box}>{error.defaultMessage}</span>}
										<Field name="shopName"
											type="text"
											placeholder={formatMessage(messages.shopName)}
											component={this.renderField}
											fieldClass={s.formControlInput}
										/>
										<label className={cx(s.signupLabel, 'signupLabelRTL')} for='shopName'>{formatMessage(messages.shopName)}</label>
									</Form.Group>
								</div>
								<div className={rs.spaceTop5}>
									<Form.Group className={cx(s.formGroup, 'signupCategorySelect')}>
										<Field name="deliveryType" className={cx(s.formControlSelect, s.formControlInput)}
											component={this.renderFormControlSelect}
											placeholder={formatMessage(messages.chooseDelivery)}
											onChange={this.changedeliveryType}
										>
											<option value="">{formatMessage(messages.typeOfDeliverly)}</option>
											{
												deliveryTypes && deliveryTypes.results && deliveryTypes.results.map((item, key) =>
													<option value={item.id} key={item.id}>{item.deliveryName}</option>
												)
											}
										</Field>
										<label className={cx(s.signupLabel, 'signupLabelRTL')} for='deliveryType'>{formatMessage(messages.typeOfDeliverly)}</label>
									</Form.Group>
								</div>
								<div className={rs.spaceTop5}>
									<Form.Group className={cx(s.formGroup, 'signupCategorySelect')}>
										<Field name="categoryType" className={cx(s.formControlSelect, s.formControlInput)}
											component={this.renderFormControlSelect}
											placeholder={formatMessage(messages.category)}
										>
											<option value="">{formatMessage(messages.chooseCategory)}</option>
											{
												categories && categories.length > 0 && categories.map((item, key) =>
													<option value={item.id} key={item.id}>{item.categoryName}</option>
												)
											}
										</Field>
										<label className={cx(s.signupLabel, 'signupLabelRTL')} for='categoryType'>{formatMessage(messages.chooseCategory)}</label>
									</Form.Group>
								</div>
								<div className={rs.spaceTop5}>
									<Form.Group className={cx(s.formGroup, 'signupCategorySelect')}>
										<Field name="locationId" className={cx(s.formControlSelect, s.formControlInput)}
											component={this.renderFormControlSelect}
										>
											{
												getLocations && getLocations.getLocations && getLocations.getLocations.map((item, key) =>
													<option value={item.id} key={item.id}>{item.locationName}</option>
												)
											}
										</Field>
										<label className={cx(s.signupLabel, 'signupLabelRTL')} for='locationId'>Operational Area</label>
									</Form.Group>
								</div>

								<div className={rs.spaceTop5}>
									<Form.Group>
										<div style={{ height: 300, width: '100%' }}>
											{this.renderMapPicker()}
										</div>
									</Form.Group>
								</div>

								<div className={rs.spaceTop5}>
									<Form.Group className={s.formGroup}>
										<div className={'singUpFormPlaceSuggest'}>
											<Field
												name="address"
												component={this.renderAddress}
											/>
											<label className={cx(s.signupLabel, 'signupLabelRTL')} for='address'>{formatMessage(messages.address)}</label>
										</div>
									</Form.Group>
								</div>
								<div className={rs.spaceTop5}>
									<Form.Group className={s.formGroup}>
										<div>
											<Field
												name="zipcode"
												type="text"
												placeholder={formatMessage(messages.zipcode)}
												component={this.renderField}
												fieldClass={s.formControlInput}
											/>
											<label className={cx(s.signupLabel, 'signupLabelRTL')} for='zipcode'>{formatMessage(messages.zipcode)}</label>
										</div>
									</Form.Group>
								</div>


								{/* Section 2: Store Owner Info */}
								<h4 className="mt-4">Store Owner Info</h4>
								<Row>
									<Col lg={6} md={12} sm={12} xs={12} className={cx(rs.spaceTop5, s.paddingReduseRight)}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="firstName"
													type="text"
													placeholder={formatMessage(messages.firstName)}
													component={this.renderField}
													labelClass={s.labelText}
													fieldClass={s.formControlInput}
												/>
												<label className={cx(s.signupLabel, 'signupLabelRTL')} for='firstName'>{formatMessage(messages.firstName)}</label>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={12} sm={12} xs={12} className={cx(rs.spaceTop5, s.paddingReduseLeft)}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="lastName"
													type="text"
													placeholder={formatMessage(messages.lastName)}
													component={this.renderField}
													labelClass={s.labelText}
													fieldClass={s.formControlInput}
												/>
												<label className={cx(s.signupLabel, 'signupLabelRTL')} for='lastName'>{formatMessage(messages.lastName)}</label>
											</div>
										</Form.Group>
									</Col>
								</Row>
								<div className={cx(rs.spaceTop5, 'storeActiveSelect', 'countryInputPhone')}>
									<Form.Group className={s.formGroup}>
										<div>
											<Field
												name="phoneNumber"
												component={this.renderPhoneNUmber}
											/>
											<label className={cx(s.signupLabel, s.phoneLabel, 'signupLabelRTL')} for='phoneNumber'>{formatMessage(messages.phoneNumber)}</label>
										</div>
									</Form.Group>
								</div>
								<div className={rs.spaceTop5}>
									<Form.Group className={s.formGroup}>
										<div>
											<Field
												name="email"
												type="text"
												placeholder={formatMessage(messages.email)}
												component={this.renderField}
												labelClass={s.labelText}
												fieldClass={s.formControlInput}
											/>
											<label className={cx(s.signupLabel, 'signupLabelRTL')} for='email'>{formatMessage(messages.email)}</label>
										</div>
									</Form.Group>
								</div>
								<div className={rs.spaceTop5}>
									<Form.Group className={s.formGroup}>
										<div>
											<Field
												name="password"
												type="password"
												placeholder={formatMessage(messages.password)}
												component={this.renderField}
												labelClass={s.labelText}
												fieldClass={s.formControlInput}
											/>
											<label className={cx(s.signupLabel, 'signupLabelRTL')} for='password'>{formatMessage(messages.password)}</label>
										</div>
									</Form.Group>
								</div>
								<div className={rs.spaceTop5}>
									<Form.Group className={s.formGroup}>
										<div>
											<Field
												name="confirmPassword"
												type="password"
												placeholder={formatMessage(messages.confirmPassword)}
												component={this.renderField}
												labelClass={s.labelText}
												fieldClass={s.formControlInput}
											/>
											<label className={cx(s.signupLabel, 'signupLabelRTL')} for='confirmPassword'>{formatMessage(messages.confirmPassword)}</label>
										</div>
									</Form.Group>
								</div>
								<div className={rs.spaceTop2}>
									<div>
										<span className={s.singupDescriction}>
											<FormattedMessage {...messages.signupPrivacyAgreement} />
										</span>
									</div>
								</div>
								<div className={cx(s.textAlignRight, rs.spaceTop5)}>
									<Form.Group className={s.formGroup}>
										<div>
											<Loader
												type={"button"}
												label={formatMessage(messages.signup)}
												show={loading}
												buttonType={'submit'}
												className={cx(s.button, s.btnPrimary, s.singUpBtn)}
												disabled={submitting || loading}
												isSuffix={true}
											/>
										</div>
									</Form.Group>
								</div>
							</Form>
						</Card>
					</div>
				</div>
			</div>
		)
	}
};

const SignupFormRedux = reduxForm({
	form: 'SignupForm',
	onSubmit: submit,
	validate
})(SignupForm);

const selector = formValueSelector('SignupForm');
const mapStateToProps = (state) => ({
	loading: state.loader.StoreSignup,
	siteName: state.siteSettings.data.siteName,
	currentLocale: state.intl.locale,
	logo: state.siteSettings.data.homeLogo,
	logoHeight: state.siteSettings.data.logoHeight,
	logoWidth: state.siteSettings.data.logoWidth,
	lat: selector(state, 'lat'),
	lng: selector(state, 'lng'),
	address: selector(state, 'address'),
	zipcode: selector(state, 'zipcode'),
});

const mapDispatchToProps = {
	openLoginModal,
	openHeaderModal,
	change: changeFieldValue
};

function SignupFormWithLoader(props) {
	const { isLoaded } = useJsApiLoader({
		googleMapsApiKey: googleMapAPI,
		libraries: ['places']
	});
	if (!isLoaded) return (
		<Spinner animation="border">
			<span className="sr-only">Loading...</span>
		</Spinner>
	);
	return <SignupFormRedux {...props} />;
}

export default compose(
	injectIntl,
	withStyles(s, rs),
	connect(mapStateToProps, mapDispatchToProps),
	graphql(getLocationsQuery, {
		name: 'getLocations',
	}),
)(SignupFormWithLoader);
